console.log('front-------------');

var dropdown = document.getElementsByClassName('wp-block-create-block-dropdown-block');

for (var i = 0; i < dropdown.length; i++) {
    var title = dropdown.item(i).querySelector('h3');
    title.onclick = function() {
      this.parentElement.classList.toggle("active");
    }
 }